import React, { useEffect } from 'react';
import { getFramework, HOTKEY_TYPE, useIdentity } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';

// 重做和撤销
const RedoUndo = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);
        const redoHandle = framework.events.on(HOTKEY_TYPE.redo, () => {
            framework.history.redo();
        });
        const undoHandle = framework.events.on(HOTKEY_TYPE.undo, () => {
            framework.history.undo();
        });
        return () => {
            framework.events.off(redoHandle);
            framework.events.off(undoHandle);
        };
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 3,
    name: 'hotkey-event-redo-undo',
    render() {
        return <RedoUndo />;
    },
};

export default exportPlugin;
